import moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function isDatetimeValid
     ****************************/
    convertDateToTimeStampUnix: function(date) {
        var unixTime = (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000;
        return unixTime;
    },
    isDatetimeValid: function(y, m, d) {
        var year = y;
        var month = m < 10 ? '0' + m : m;
        var day = d < 10 ? '0' + d : d;
        var dateFormat = year + '-' + month + '-' + day;

        return moment(dateFormat).isValid();
    },

    /********** Date Format ***********
     * @function dateFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/
    dateFullFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            moment.locale('en');
        } else {
            moment.locale('th');
        }
        var strDate = moment.unix(timestamp).utc().format('DD MMMM ');
        var year = moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);

        return strDate + year;
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function(timestamp) {
        var strDate = moment.unix(timestamp).utc().format('HH:mm:ss');
        return strDate;
    },
    dateShortFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            moment.locale('en');
        } else {
            moment.locale('th');
        }
        var strDate = moment.unix(timestamp).utc().format('DD/MM/');
        var year = moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);
        var yearShort = year.toString().substring(2,4);
        return strDate + yearShort;
    },
    getDateTimeGTM: function() {
        return moment().format("YYYYMMDD HH:mm:ss")
    }

}
